// extracted by mini-css-extract-plugin
module.exports = {"firstDelivery":"index-module__firstDelivery___OrPDI","firstDeliveryLabel":"index-module__firstDeliveryLabel___2guBS"};